export default "__VITE_ASSET__B2EbZ$Ul__"